<template>
  <transition name="a">
    <div class="iframe-container" v-show="show">
      <p class="btn-wraper">
        <span @click="goP">{{$t('Previous')}}</span>
        <span @click="goN">{{$t("Next")}}</span>
        <i>{{$t("Page")+idx+" / "+totalPage}}</i>
      </p>
      <p class="close" @click="close">X</p>
      <div class="canvas" v-show="ispdf">
        <canvas ref="canvas_dom"></canvas>
      </div>
      <iframe :src="src" v-if="!ispdf"></iframe>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["src", "show"],
  computed: {
    ispdf() {
      return /\.pdf$/.test(this.src);
    }
  },
  watch: {
    src(n, o) {
      if (this.ispdf) {
        this.idx = 1;
        this.getPDF(n);
      }
    }
  },
  data() {
    return {
      idx: 1,
      totalPage: 0,
      pdf: null
    };
  },
  methods: {
    getPDF(url) {
      pdfjsLib.getDocument(url).promise.then(pdf => {
        this.pdf = pdf;
        this.totalPage = pdf._pdfInfo.numPages;
        this.renderCanvas();
      });
    },
    renderCanvas() {
      this.pdf.getPage(this.idx).then(page => {
        // 得到 PDF 文件的第n页
        var canvas = this.$refs.canvas_dom;
        var viewport = page.getViewport({ scale: 2 }); // 根据 PDF 页面信息得到视图
        var context = canvas.getContext("2d"); // 指定 canvas 画布按 2D 方式渲染

        // 设定画布大小
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // 设定渲染参数
        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        // 渲染页面
        page.render(renderContext);
      });
    },
    goP() {
      if (this.idx > 1) {
        this.renderCanvas(--this.idx);
      }
    },
    goN() {
      if (this.idx < this.totalPage) {
        this.renderCanvas(++this.idx);
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang='less' scoped>
.a-enter-active,
.a-leave-active {
  transform: translateX(0);
}
.a-enter,
.a-leave-to {
  transform: translateX(100%);
}
.iframe-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: #fff;
  transition: all 0.5s ease;
}
.btn-wraper {
  margin: 0.4rem;
  display: flex;
  align-items: center;
  span {
    padding: 5px;
    margin-right: 0.2rem;
    font-size: 0.28rem;
    color: #fff;
    background: #ff7d41;
    border-radius: 4px;
  }
  i {
    font-size: 0.32rem;
    font-style: normal;
  }
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  background: #000;
  width: 0.6rem;
  height: 0.6rem;
  font-size: 0.4rem;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 50%;
}

.canvas {
  width: 100%;
}
canvas,
iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
</style>

